import type { ListingQualityResult } from "@/app/api/auth-client";

export function listingQualityTierLabel(tier: string | undefined): string {
  switch ((tier ?? "").toLowerCase()) {
    case "high":
      return "Alta";
    case "medium":
      return "Média";
    case "low":
      return "Baixa";
    default:
      return "—";
  }
}

export function listingQualityTierColorClass(tier: string | undefined): string {
  switch ((tier ?? "").toLowerCase()) {
    case "high":
      return "text-green-700 bg-green-50 border-green-200";
    case "medium":
      return "text-amber-800 bg-amber-50 border-amber-200";
    case "low":
      return "text-red-700 bg-red-50 border-red-200";
    default:
      return "text-muted-foreground bg-muted border-border";
  }
}

export function listingQualityBarColorClass(tier: string | undefined): string {
  switch ((tier ?? "").toLowerCase()) {
    case "high":
      return "bg-green-500";
    case "medium":
      return "bg-amber-500";
    case "low":
      return "bg-red-500";
    default:
      return "bg-muted-foreground";
  }
}

export function hasPersistedListingQuality(score: number | undefined, version: string | undefined): boolean {
  return (score != null && score > 0) || Boolean(version?.trim());
}

/** Hide "Ver como melhorar" when the ad already scores 100/100. */
export function shouldShowListingQualityImproveLink(
  score: number | undefined,
  pendingQuality: boolean
): boolean {
  if (pendingQuality) return true;
  return score == null || score < 100;
}

export function listingQualityIssuesForDisplay(result: ListingQualityResult | null): {
  met: string[];
  gaps: ListingQualityResult["issues"];
} {
  if (!result) return { met: [], gaps: [] };
  const issues = result.issues ?? [];
  const gaps = issues.filter((i) => i.knockout || (i.points_lost ?? 0) > 0);
  const met: string[] = [];
  if (result.has_photos) met.push("Fotos");
  if (!issues.some((i) => i.code.startsWith("title"))) met.push("Título");
  if (!issues.some((i) => i.code.startsWith("description"))) met.push("Descrição");
  if (!issues.some((i) => i.code === "price_invalid")) met.push("Preço");
  if (!issues.some((i) => i.code === "category_missing")) met.push("Categoria");
  if (!issues.some((i) => i.code.startsWith("shipping"))) met.push("Frete");
  if (!issues.some((i) => i.code === "location_missing")) met.push("Localização");
  if (!issues.some((i) => i.code === "attributes_incomplete")) met.push("Detalhes da categoria");
  return { met, gaps };
}

/** Placeholder paths so BFF counts photos during create/edit preview before upload. */
export function previewUserImagesFromCount(count: number): string[] {
  return Array.from({ length: Math.max(0, count) }, (_, i) => `pending-${i}`);
}
